/**
 * Black Mango — Wishlist (localStorage-based)
 * Adds heart toggle to [data-wishlist-toggle] buttons.
 * Stores product handles in localStorage key 'bm_wishlist'.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'bm_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    const list = getWishlist();
    const index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    updateAllButtons();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }

  function updateAllButtons() {
    const buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (const btn of buttons) {
      const handle = btn.dataset.wishlistToggle;
      const active = isInWishlist(handle);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  /* Bind click events via delegation */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn.dataset.wishlistToggle);
  });

  /* Initial state on page load */
  updateAllButtons();

  /* Re-sync if another tab changes localStorage */
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) updateAllButtons();
  });
})();
